window.mobileNavIcons = {
    chevronRight:
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.8999 2.41L5.3099 1L12.3099 8L5.3099 15L3.8999 13.59L9.4799 8L3.8999 2.41Z" fill="#54545C"/>' +
        '</svg>'
};
(function () {
    var MOBILE_NAV_BREAKPOINT = 992;
    var resizeTimer;

    window.fisherMobileNavInitialized = window.fisherMobileNavInitialized || false;

    function shouldInitMobileNav() {
        return window.innerWidth < MOBILE_NAV_BREAKPOINT;
    }

    function initMobileNavOnce() {
        if (window.fisherMobileNavInitialized) return;
        if (!shouldInitMobileNav()) return;

        window.fisherMobileNavInitialized = true;

        initMobileNav();
    }
    function initMobileNav() {
    var navData = typeof navigationData !== "undefined"
        ? navigationData
        : window.navigationData;
    var mobileNavLinksData = typeof mobileNavLinks !== "undefined"
        ? mobileNavLinks
        : window.mobileNavLinks;
    var shopAllLabel = window.shopAllText || "Shop All";
    var browseAllLabel;

    if (nav) {
        nav.style.display = "";
    }



    var nav = document.getElementById("mobileNav");
    var overlay = document.getElementById("mobileNavOverlay");
    var openButton = document.getElementById("open-main-drawer");

    var mainMenu = document.getElementById("mainMenu");
    var categoryTitle = document.getElementById("categoryTitle");
    var categoryMenu = document.getElementById("categoryMenu");
    var drawerTitle = document.getElementById("drawerTitle");
    var drawerBody = document.getElementById("drawerBody");

    if (!nav || !navData || !mainMenu || !categoryMenu || !drawerBody) return;

    var panels = {
        main: nav.querySelector('[data-panel="main"]'),
        category: nav.querySelector('[data-panel="category"]'),
        drawer: nav.querySelector('[data-panel="drawer"]')
    };

    var state = {
        stack: ["main"],
        activeParentKey: null,
        activeContentId: null,
        lastFocusedElement: null
    };

        var lastInputWasKeyboard = false;

        var lastInputWasKeyboard = false;

        document.addEventListener("keydown", function () {
            lastInputWasKeyboard = true;
        });

        document.addEventListener("pointerdown", function () {
            lastInputWasKeyboard = false;
        });

        document.addEventListener("mousedown", function () {
            lastInputWasKeyboard = false;
        });

        document.addEventListener("touchstart", function () {
            lastInputWasKeyboard = false;
        });

    function escapeHtml(value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function closest(el, selector) {
        while (el && el !== document) {
            if (el.matches && el.matches(selector)) return el;
            el = el.parentNode;
        }
        return null;
    }

    function getOrderedNavItems() {
        return Object.keys(navData)
            .sort(function (a, b) {
                return Number(a) - Number(b);
            })
            .map(function (key) {
                return {
                    key: key,
                    item: navData[key]
                };
            });
    }

    function getParentItem(parentKey) {
        return navData[parentKey];
    }

    function getContentItem(parentKey, contentId) {
        var parent = getParentItem(parentKey);
        return parent && parent.content ? parent.content[contentId] : null;
    }

    function getDefaultContentId(parent) {
        var i;

        if (!parent || !parent.sidebar || !parent.sidebar.length) return null;

        for (i = 0; i < parent.sidebar.length; i++) {
            if (parent.sidebar[i].active) {
                return parent.sidebar[i].id;
            }
        }

        return parent.sidebar[0].id;
    }

    function renderMain() {
        var html = '<ul class="mobile-nav__list">';

        getOrderedNavItems().forEach(function (entry, index) {
            var item = entry.item;
            var analyticsText = item.parentLabel + "|" + (index + 1);
            var analyticsAttrs =
                ' data-analytics-section="Global Nav"' +
                ' data-analytics-container="Fisher Scientific"' +
                ' data-analytics-parent=""' +
                ' data-analytics-text="' + escapeHtml(analyticsText) + '"';

            //Skip certain links for mobile
            if(item.linkOnly && !item.showInMobile){
                return;
            }

            if (item.linkOnly) {
                html +=
                    '<li>' +
                    '<a class="mobile-nav__link" href="' + escapeHtml(item.href) + '"' + analyticsAttrs + '>' +
                    escapeHtml(item.parentLabel) +
                    '</a>' +
                    '</li>';

                return;
            }

            html +=
                '<li>' +
                '<button class="mobile-nav__item" type="button" data-open-parent="' + escapeHtml(entry.key) + '"' + analyticsAttrs + '>' +
                '<span class="mobile-nav__item-label">' +
                escapeHtml(item.parentLabel) +
                '</span>' +

                '<span class="mobile-nav__item-icon" aria-hidden="true">' +
                window.mobileNavIcons.chevronRight +
                '</span>' +
                '</button>' +
                '</li>';
        });

        var isGuestUser =
            window.utils &&
            typeof window.utils.getCookie === "function" &&
            window.utils.getCookie("usertype") === "G";

        getMobileNavLinks().forEach(function (link) {

            if (link.registeredUserOnly && isGuestUser) {
                return;
            }
            var finalLink = escapeHtml(link.href);
            var isSignOut = link.isSignOut;
            var customClass = link.customClass || "";

            if(link.useLocale) {
                finalLink = localeUrlPath + escapeHtml(link.href);
            }

            var analyticsAttrs =
                ' data-analytics-section="Global Nav"' +
                ' data-analytics-container="Fisher Scientific"' +
                ' data-analytics-parent="Header"' +
                ' data-analytics-text="' + escapeHtml(link.label) + '"';

            html +=
                '<li class="' + (isSignOut ? "mobile-nav__item--separated" : "") + ' ' + customClass + '">' +
                '<a class="mobile-nav__link" href="' + finalLink + '"' + analyticsAttrs + '>' +
                escapeHtml(link.label) +
                '</a>' +
                '</li>';
        });

        html += "</ul>";
        mainMenu.innerHTML = html;
    }

    function renderParentPanel(parentKey) {
        var parent = getParentItem(parentKey);
        var html;


        if (!parent) return;

        categoryTitle.textContent = "Main Menu";

        html =
            '<div class="mobile-nav__section-heading">' +
            escapeHtml(parent.parentLabel) +
            '</div>' +
            '<ul class="mobile-nav__list">';

        if (parent.sidebar && parent.sidebar.length) {
            parent.sidebar.forEach(function (sidebarItem) {
                var content = getContentItem(parentKey, sidebarItem.id);
                var label = sidebarItem.label || (content && content.title) || sidebarItem.id;

                html +=
                    '<li>' +
                    '<button class="mobile-nav__item" type="button" data-open-content="' + escapeHtml(sidebarItem.id) + '">' +

                    '<span class="mobile-nav__item-label">' +
                    escapeHtml(label) +
                    '</span>' +

                    '<span class="mobile-nav__item-icon" aria-hidden="true">' +
                    window.mobileNavIcons.chevronRight +
                    '</span>' +

                    '</button>' +
                    '</li>';
            });
        }

        html += "</ul>";

        if (parent.footer && parent.footer.length) {
            html += '<div class="mobile-nav__footer">';

            parent.footer.forEach(function (link) {
                var finalLink = escapeHtml(link.href);
                if(link.useLocale) {
                    finalLink = localeUrlPath + finalLink;
                }
                html +=
                    '<a class="mobile-nav__link" href="' + finalLink + '">' +
                    escapeHtml(link.text) +
                    '</a>';
            });

            html += "</div>";
        }

        categoryMenu.innerHTML = html;
    }

    function getFocusableElements(container) {
        return Array.prototype.slice.call(
            container.querySelectorAll(
                'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
        ).filter(function (el) {
            return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        });
    }

    function isTouchDevice() {
        return window.matchMedia &&
            window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    }

    function focusFirstElement(panel, focusMode) {
            var focusable;
            var preferredFocus;
            var i;

            panel.scrollLeft = 0;

            focusable = getFocusableElements(panel);

            if (!focusable.length) return;

            if (focusMode === "back") {
                preferredFocus = panel.querySelector("[data-back]");
            }

            if (preferredFocus && focusable.indexOf(preferredFocus) === -1) {
                preferredFocus = null;
            }

            if (!preferredFocus) {
                for (i = 0; i < focusable.length; i++) {
                    if (
                        focusable[i].classList.contains("mobile-nav__item") ||
                        focusable[i].classList.contains("mobile-nav__link")
                    ) {
                        preferredFocus = focusable[i];
                        break;
                    }
                }
            }

            if (!preferredFocus) {
                preferredFocus = focusable[0];
            }

            window.setTimeout(function () {
                panel.scrollLeft = 0;

                try {
                    preferredFocus.focus({ preventScroll: true });
                } catch (e) {
                    preferredFocus.focus();
                }

                console.log("Focused:", document.activeElement);
            }, 50);
        }

    function setPanelAccessibility(activePanelName) {
        Object.keys(panels).forEach(function (key) {
            var panel = panels[key];
            var isActive = key === activePanelName;

            if (!panel) return;

            if (isActive) {
                panel.removeAttribute("inert");
                panel.setAttribute("aria-hidden", "false");
            } else {
                panel.setAttribute("inert", "");
                panel.setAttribute("aria-hidden", "true");
            }
        });
    }

    function showPanel(panelName, shouldFocus, focusMode) {
        Object.keys(panels).forEach(function (key) {
            if (!panels[key]) return;
            panels[key].classList.remove("is-active", "is-previous");
        });

        var activeIndex = state.stack.indexOf(panelName);

        state.stack.forEach(function (name, index) {
            if (!panels[name]) return;

            if (index < activeIndex) {
                panels[name].classList.add("is-previous");
            }
        });

        panels[panelName].classList.add("is-active");
        setPanelAccessibility(panelName);

        panels[panelName].scrollLeft = 0;

        if (shouldFocus && lastInputWasKeyboard) {
            focusFirstElement(panels[panelName], focusMode);
        }
    }

    function lockBodyScroll() {
        document.documentElement.classList.add("mobile-nav-open");
        document.body.classList.add("mobile-nav-open");
    }

    function unlockBodyScroll() {
        document.documentElement.classList.remove("mobile-nav-open");
        document.body.classList.remove("mobile-nav-open");
    }

    function openNav() {
        state.lastFocusedElement = document.activeElement;
        nav.style.display = "";
        nav.classList.add("is-open");
        nav.removeAttribute("inert");
        nav.setAttribute("aria-hidden", "false");

        if (openButton) {
            openButton.setAttribute("aria-expanded", "true");
        }

        if (overlay) {
            overlay.hidden = false;
        }

        lockBodyScroll();

        state.stack = ["main"];
        state.activeParentKey = null;
        state.activeContentId = null;

        showPanel("main", true, "first");
    }

    function closeNav() {
        let background = document.querySelector('.full-bg');
        nav.classList.remove("is-open");
        nav.parentElement.classList.remove("open");
        nav.setAttribute("inert", "");
        nav.setAttribute("aria-hidden", "true");

        if (openButton) {
            openButton.setAttribute("aria-expanded", "false");
        }

        if (overlay) {
            overlay.hidden = true;
        }

        if(background) {
            background.classList.remove("open");
        }

        unlockBodyScroll();

        if (state.lastFocusedElement && state.lastFocusedElement.focus) {
            state.lastFocusedElement.focus();
        } else if (openButton) {
            openButton.focus();
        }
    }

    function renderCategoryContentPanel(parentKey, contentId) {
        var parent = getParentItem(parentKey);
        var content = getContentItem(parentKey, contentId);

        if (!parent || !content) return;

        if (categoryTitle) {
            categoryTitle.textContent = "Main Menu";
        }

        categoryMenu.innerHTML = buildContentHtml(parent, content);
    }

    function openParent(parentKey) {
        var parent = getParentItem(parentKey);
        var defaultContentId;
        var defaultSidebarItem;

        if (!parent) return;

        state.activeParentKey = parentKey;
        state.activeContentId = null;

        defaultContentId = getDefaultContentId(parent);

        if (parent.sidebar && parent.sidebar.length === 1) {
            defaultSidebarItem = parent.sidebar[0];

            if (defaultSidebarItem.hideSidebar && defaultContentId) {
                state.activeContentId = defaultContentId;

                renderCategoryContentPanel(parentKey, defaultContentId);

                state.stack = ["main", "category"];
                showPanel("category", true, "back");

                return;
            }
        }

        renderParentPanel(parentKey);

        state.stack = ["main", "category"];
        showPanel("category", true);
    }

    function renderContentPanel(parentKey, contentId) {
        var parent = getParentItem(parentKey);
        var content = getContentItem(parentKey, contentId);

        if (!parent || !content) return;

        if (drawerTitle) {
            drawerTitle.textContent = parent.parentLabel;
        }

        drawerBody.innerHTML = buildContentHtml(parent, content);
    }

    function buildContentHtml(parent, content) {
        var html = "";

        if (content.columns && content.columns.length) {
            content.columns.forEach(function (column) {
                var headerTitle = column.title || content.title || parent.parentLabel;
                var headerHref = column.shopAllHref || content.shopAllHref;
                var showShopAll = !!headerHref && (column.shopAll || content.shopAll);

                var shopOrBrowseAll =
                    headerTitle &&
                    (
                        headerTitle.toLowerCase() === "programs" ||
                        headerTitle.toLowerCase() === "services"
                    )
                        ? (typeof browseAllText !== "undefined" ? browseAllText : "Browse All")
                        : (typeof shopAllText !== "undefined" ? shopAllText : shopAllLabel);

                if (headerTitle) {
                    if (showShopAll) {
                        html +=
                            '<a class="mobile-nav__section-header mobile-nav__section-header--link" href="' + (content.useLocale ? localeUrlPath : "") + escapeHtml(headerHref) + '">' +
                            '<h3 class="mobile-nav__section-title">' +
                            escapeHtml(headerTitle) +
                            '</h3>' +
                            '<span class="mobile-nav__section-action">' +
                            escapeHtml(shopOrBrowseAll) +
                            '</span>' +
                            '</a>';
                    } else {
                        html +=
                            '<div class="mobile-nav__section-header">' +
                            '<h3 class="mobile-nav__section-title">' +
                            escapeHtml(headerTitle) +
                            '</h3>' +
                            '</div>';
                    }
                }

                html += '<ul class="mobile-nav__list">';

                if (column.links && column.links.length) {
                    column.links.forEach(function (link) {
                        var finalLink = escapeHtml(link.href);
                        if(link.useLocale) {
                            finalLink = localeUrlPath + finalLink;
                        }
                        var linkClass = "mobile-nav__link";

                        if (link.class) {
                            linkClass += " " + link.class;
                        }

                        if (link.renderAsButton) {
                            linkClass += " mobile-nav__link--button";
                        }

                        html +=
                            '<li>' +
                            '<a class="' + escapeHtml(linkClass) + '" href="' + finalLink + '">' +
                            escapeHtml(link.text) +
                            '</a>' +
                            '</li>';
                    });
                }

                html += '</ul>';
            });
        }

        return html;
    }

    function openContent(contentId) {
        var content;

        if (state.activeParentKey == null) return;

        content = getContentItem(state.activeParentKey, contentId);
        if (!content) return;

        state.activeContentId = contentId;

        renderContentPanel(state.activeParentKey, contentId);
        state.stack = ["main", "category", "drawer"];

        requestAnimationFrame(function () {
            showPanel("drawer", true, "back");
        });
    }

    function goBack() {
        if (state.stack.length <= 1) return;

        state.stack.pop();
        showPanel(state.stack[state.stack.length - 1], true, "back");
    }

    function trapFocus(event) {
        var activePanelName;
        var activePanel;
        var focusable;
        var first;
        var last;

        if (!nav.classList.contains("is-open")) return;
        if (event.key !== "Tab") return;

        activePanelName = state.stack[state.stack.length - 1];
        activePanel = panels[activePanelName];

        if (!activePanel) return;

        focusable = getFocusableElements(activePanel);

        if (!focusable.length) {
            event.preventDefault();
            return;
        }

        first = focusable[0];
        last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }
    function getMobileNavLinks() {
        if (!mobileNavLinksData) {
            return [];
        }

        return Object.keys(mobileNavLinksData)
            .sort(function (a, b) {
                return Number(a) - Number(b);
            })
            .map(function (key) {
                return mobileNavLinksData[key];
            });
    }

    function removeAccountSpecificLinks() {
        const newItemLinks = document.querySelectorAll('a[href*="new-item.html"]');

        if (newItemLinks.length === 1) {
            document.querySelectorAll(".request-a-new-item").forEach(function (el) {
                el.remove();
            });
        }
    }

    nav.addEventListener("click", function (event) {
        var parentButton = closest(event.target, "[data-open-parent]");
        var contentButton = closest(event.target, "[data-open-content]");
        var backButton = closest(event.target, "[data-back]");
        var closeButton = closest(event.target, "[data-close]");

        if (parentButton) {
            openParent(parentButton.getAttribute("data-open-parent"));
            return;
        }

        if (contentButton) {
            openContent(contentButton.getAttribute("data-open-content"));
            return;
        }

        if (backButton) {
            goBack();
            return;
        }

        if (closeButton) {
            closeNav();
        }
    });

    document.addEventListener("keydown", function (event) {
        var key = event.key || event.keyCode;

        if ((key === "Escape" || key === 27) && nav.classList.contains("is-open")) {
            closeNav();
            return;
        }

        trapFocus(event);
    });

    if (openButton) {
        openButton.addEventListener("click", openNav);
    }

    if (overlay) {
        overlay.addEventListener("click", closeNav);
    }

        renderMain();
        setPanelAccessibility("main");
        nav.setAttribute("aria-hidden", "true");
        nav.setAttribute("inert", "");
        if (openButton) {
            openButton.setAttribute("aria-expanded", "false");
        }

        removeAccountSpecificLinks();

    }

    initMobileNavOnce();

    window.addEventListener("resize", function () {
        window.clearTimeout(resizeTimer);

        resizeTimer = window.setTimeout(function () {
            initMobileNavOnce();
        }, 150);
    });
})();